//动态版本增加
//第二页开始需要加上data-transition-active="true"

// 从主导航直接进入戒托集合，代表开始一次新的定制流程。
// diamond-first / modify-ring 是流程内跳转，需要保留已选钻石。
var ringFlow = new URLSearchParams(window.location.search).get('flow');
if (ringFlow !== 'diamond-first' && ringFlow !== 'modify-ring') {
    sessionStorage.removeItem('wooSpecData');
    localStorage.removeItem('wooSpecData');
}

//根据提交的表单查询商品
var baseUrl = 'https://wv.valthea.com/20204';

// 跨平台兼容配置
const config = {
    threshold: 100,          // 触底阈值(px)
    maxPullDown: 150,        // 最大下拉距离(px)
    debounceTime: 200,       // 防抖时间(ms)
    isMobile: /Mobi|Android|iPhone/i.test(navigator.userAgent)
};

// 状态管理
const state = {
    page: 0,
    isLoading: false,
    startY: 0,
    isRefreshing: false,
    lastScrollTime: 0
};

var wooviewParamsObject = {};

// DOM元素
const container = document.querySelector("[data-body-wrapper]");
const content = container ? container.querySelector("[data-body-grid]") : null;
const loading = document.getElementById('loading');
const refreshIndicator = document.getElementById('refreshIndicator');

function showLoading() {
    if (!loading) return;
    loading.classList.toggle('is-initial', !content || content.children.length === 0);
    loading.classList.add('is-active');
}

function hideLoading() {
    if (!loading) return;
    loading.classList.remove('is-active');
    loading.classList.remove('is-initial');
}

// 初始化内容
function initContent() {
    wooviewInitNavigation();
    addItem();
    state.page++;
}
function renderDiamondGridHtml(paramsObject){
    if(paramsObject){
        wooviewParamsObject = paramsObject;
    }

    refreshData();
}

function skuMatchesSelectedMetal(sku, metal) {
    if (!sku || !sku.specSkuValue || !metal) return false;
    return String(sku.specSkuValue).toLowerCase().includes(String(metal).trim().toLowerCase());
}

async function applySelectedMetalToCards(items) {
    var metals = Array.from(new Set((wooviewParamsObject.metals || []).filter(function (metal) {
        return metal && metal.trim();
    })));
    if (metals.length === 0 || !Array.isArray(items) || items.length === 0) return items;

    var expandedItems = await Promise.all(items.map(async function (item) {
        try {
            var detailsUrl = baseUrl + '/store/product/details/' + encodeURIComponent(item.productId)
                + '?shopDomain=' + encodeURIComponent('https://' + Shopify.shop);
            var response = await fetch(detailsUrl);
            if (!response.ok) return [item];

            var result = await response.json();
            var product = result && result.data && result.data.product;
            var combination = product && product.skuCombination;
            var skuList = combination && Array.isArray(combination.productSkuList)
                ? combination.productSkuList
                : [];
            var metalCards = [];

            metals.forEach(function (selectedMetal) {
                var matchingSkus = skuList.filter(function (sku) {
                    return skuMatchesSelectedMetal(sku, selectedMetal);
                });
                if (matchingSkus.length === 0) return;

                matchingSkus.sort(function (left, right) {
                    var leftPrice = Number(left.productPrice);
                    var rightPrice = Number(right.productPrice);
                    if (!Number.isFinite(leftPrice)) return 1;
                    if (!Number.isFinite(rightPrice)) return -1;
                    return leftPrice - rightPrice;
                });

                var selectedSku = matchingSkus[0];
                var cardItem = Object.assign({}, item, {selectedMetal: selectedMetal});
                if (selectedSku.imageUrl) cardItem.pictures = selectedSku.imageUrl;
                if (Number.isFinite(Number(selectedSku.productPrice))) {
                    cardItem.price = Number(selectedSku.productPrice);
                }
                metalCards.push(cardItem);
            });

            return metalCards.length > 0 ? metalCards : [item];
        } catch (error) {
            // Keep the default card presentation if one product's detail request fails.
            console.warn('Unable to load selected metal presentation', item.productId, error);
            return [item];
        }
    }));

    return expandedItems.reduce(function (cards, productCards) {
        return cards.concat(productCards);
    }, []);
}

async function fetchProducts(callback) {
    const url = baseUrl+'/store/product/ring/list';
    wooviewParamsObject.page = state.page;
    wooviewParamsObject.shopDomain="https://"+Shopify.shop;
    wooviewParamsObject.productType = 1;
    wooviewParamsObject.bands = [];
    if(wooviewParamsObject.styles && wooviewParamsObject.styles[0]=="All"){
        wooviewParamsObject.styles=[];
    }
    showLoading();
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(wooviewParamsObject)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();
        if (responseData && Array.isArray(responseData.content)) {
            responseData.content = await applySelectedMetalToCards(responseData.content);
        }
        callback(responseData)
    } catch (error) {
        console.error('POST request error:', error);
        throw error;
    } finally {
        hideLoading();
    }
   // return woohtml;
}

// 添加项目元素
function addItem() {
    fetchProducts(function (data) {
        if(data && data.content.length>0){
            var html = '';
            data.content.forEach(function (item,i) {
                if((i + 1) % 8 === 0){
                    html+=`<div class="collection-promo--root"  data-transition-active="true" data-promo-width="4" data-background-color="none" data-border-type="none" data-transition-item="template--24075745886242__main">
<picture class="image--root " data-background="false" data-display-type="fill-available" data-full-width="" data-mobile-display-type="fill-available" data-mobile-full-width="" data-mobile-overlay-style="darken-bottom" data-parallax="false" data-overlay-style="darken-bottom" style="--aspect-ratio:0.8333;--mobile-aspect-ratio:0.8333;"><img src="//cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=1665" alt="" srcset="//cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=200 200w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=300 300w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=400 400w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=500 500w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=600 600w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=700 700w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=800 800w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=900 900w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=1000 1000w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=1200 1200w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=1400 1400w, //cdn.shopify.com/s/files/1/0621/2875/0690/files/ring-setting_desktop.jpg?v=1778504707;width=1600 1600w" width="1665" height="1998" loading="lazy" sizes="(max-width: 767px) calc(100vw - 32px), calc(100vw - 96px)">
</picture><div class="stacked-text--root" data-text-color="body" data-mobile-y-alignment="center" data-x-alignment="center" data-y-alignment="center" data-width="medium">
    <div class="stacked-text--wrapper" data-text-style="none" data-background-color="transparent" data-translucent="true" data-container="block" data-transition-container="grid-promo-1" data-transition-type="slide-in" data-transition-cascade="vertical" data-transition-cascade-interval="500"><div data-transition-item="grid-promo-1">
          <h2 class="stacked-text--title" data-item="section-heading">Can't find the perfect Round Brilliant?</h2>
        </div><div class="stacked-text--description" data-item="featured-paragraph" data-transition-item="grid-promo-1"><p>We’ll cut and polish one for you — in any size.</p></div><a class="stacked-text--button" href="" data-item="button" data-text="Discover Cut for You™" data-transition-item="grid-promo-1" data-transition-type="fade-in" data-transition-button="">
            <span>Discover Cut for You™</span>
          </a></div>
  </div></div>`;
                }else{
                    var transitionActive = 'data-transition-active="true"';
                    /*if(i==0){
                        transitionActive='';
                    }*/
                    var hoverImage = '';

                    if(item.pictures){
                        var pictures = item.pictures.split(",");
                        hoverImage = pictures.length>1?pictures[1]:pictures[0];
                        if(!item.imageUrl){
                            item.imageUrl = pictures[0];
                        }
                    }

                    var price =Intl.NumberFormat("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.price);
                    var productTitle = ValtheaCollectionCards.escapeHtml(item.name);

                    html += `<div class="product-card--root valthea-enhanced-card" ${transitionActive} data-handle="${item.urlHandle}" data-product-item="" data-text-layout="center" data-container="block" data-aspect-ratio="square" data-transition-item="template--24075745886242__main">
                  ${ValtheaCollectionCards.renderMedia(item, hoverImage, 'ring')}

                  <div class="product-card--details">
                    <div class="product-card--details-wrapper"><a href="/products/${item.urlHandle}" class="product-card--title-link">
                        <p class="product-card--title" data-item="paragraph" title="${productTitle}">${productTitle}</p>
                      </a></div><div class="product--price-container">
                  <div class="product--price-wrapper"><span class="product--price" data-item="nav-text">$${price}</span>
                  </div></div></div>
                  ${ValtheaCollectionCards.renderCta(item)}
                </div>`;
                }

            });
            content.insertAdjacentHTML('beforeend', html);
        }else{
            return;
        }
    });


   // content.appendChild(html);
    //content.removeAttribute("style");
    
}

// 防抖函数
function debounce(fn, delay) {
    let timer = null;
    return function() {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, arguments), delay);
    };
}

// 加载更多数据
function loadMoreData() {
    if (state.isLoading) return;

    state.isLoading = true;

    setTimeout(() => {
        addItem();

    state.page++;
    state.isLoading = false;
}, 800);
}

// 触底检测逻辑
function checkScroll() {
    const now = Date.now();
    if (now - state.lastScrollTime < config.debounceTime) return;
    state.lastScrollTime = now;

    const { scrollTop, clientHeight, scrollHeight } = container;
    if (scrollTop + clientHeight >= scrollHeight - config.threshold) {
        loadMoreData();
    }
}

// 鼠标滚轮事件处理(PC端)
function handleWheel(e) {
    if (e.deltaY > 0) checkScroll();
}

// 触摸事件处理(移动端)
function handleTouchStart(e) {
    if (container.scrollTop === 0) {
        state.startY = e.touches[0].clientY;
    }
}

function handleTouchMove(e) {
    if (container.scrollTop === 0 && !state.isRefreshing) {
        const currentY = e.touches[0].clientY;
        const diff = currentY - state.startY;

        if (diff > 0) {
            e.preventDefault();
            const progress = Math.min(diff, config.maxPullDown);
            //refreshIndicator.textContent = progress > 100 ? '释放刷新 ↑' : '下拉刷新 ↓';
            refreshIndicator.style.transform = `translateY(${progress}px)`;
        }
    }
}

function handleTouchEnd() {
    const currentY = parseInt(refreshIndicator.style.transform.match(/\d+/));
    if (container.scrollTop === 0 && currentY > 100) {
        refreshData();
    } else {
        refreshIndicator.style.transform = 'translateY(-100%)';
    }
}

// 刷新数据
function refreshData() {
    if (state.isRefreshing) return;

    state.isRefreshing = true;
    //refreshIndicator.textContent = '刷新中...';
    showLoading();
    setTimeout(() => {
        content.innerHTML = '';
    state.page = 0;
    initContent();
    //refreshIndicator.textContent = '刷新完成 ✓';
    setTimeout(() => {
        refreshIndicator.style.transform = 'translateY(-100%)';
    state.isRefreshing = false;
}, 500);
}, 500);
}

// 事件监听
function setupListeners() {
    // 公共事件
    container.addEventListener('scroll', debounce(checkScroll, config.debounceTime));

    // 平台特定事件
    if (config.isMobile) {
        container.addEventListener('touchstart', handleTouchStart);
        container.addEventListener('touchmove', handleTouchMove);
        container.addEventListener('touchend', handleTouchEnd);
    } else {
        container.addEventListener('wheel', handleWheel);
       // refreshIndicator.textContent = '↓ 点击刷新';
       // refreshIndicator.addEventListener('click', refreshData);
    }

    wv$(document).on('click', '.filter__inputs a', function(e) {
        e.preventDefault(); // 阻止默认链接行为
        var checkbox = wv$(this).find('input[type="checkbox"]');

        if(wv$(this).hasClass("filter_active")){
            wv$(this).removeClass("filter_active");
            checkbox.prop('checked', false);
        }else{
            wv$(this).addClass("filter_active");
            checkbox.prop('checked', true);
        }

        refreshData();
    });
    wv$(document).on('click', '.style-select-but', function(e) {

        var selectText = wv$(".style-select-text");
        var svg = wv$(this).find("svg");

        if(selectText.hasClass("hidden")){
            selectText.removeClass("hidden");
            svg.addClass("rotate-[-90deg]");
            svg.removeClass("rotate-90");
        }else{
            selectText.addClass("hidden");
            svg.removeClass("rotate-[-90deg]");
            svg.addClass("rotate-90");
        }

    });

    wv$(document).on('click', '.style-select-text .style_checkbox', function(e) {
        e.preventDefault(); // 阻止默认链接行为
        var styleText = wv$(this).text();
        wv$(this).addClass("filter_active");
        wv$(".select-style-text").text(styleText);
        var checkboxes = wv$('input[type="checkbox"][name="style"]');
        wv$(checkboxes[0]).val(styleText);
        wv$(".style-select-text").addClass("hidden");
        refreshData();
    });
}

function formDataToObject(urlParams) {

    // 获取所有shape参数（处理重复键）
    const metals = urlParams.getAll('metal'); // 返回数组：["Round Brilliant", "Oval", "Emerald", "Pear"]
    // BAND filtering is disabled; ignore band parameters in old links.
    const bands = [];
    const styles = urlParams.getAll('style'); // 返回数组
    const shapes = urlParams.getAll('shape'); // 裸钻优先流程：根据已选裸钻 shape 筛选戒托


    const params = {
        metals: metals,
        bands:bands,
        styles:styles,
        shapes:Array.from(new Set(shapes))
    };
    return  params;
}

function wooviewInitNavigation() {
    var navigation = document.querySelector('.navigation--root');
    var url = navigation ? navigation.getAttribute("data-url") : window.location.pathname + '?';
    var filter = document.querySelector("#filter__inputs");
    var currentParams = new URLSearchParams(window.location.search);
    var e;

    if (filter instanceof HTMLFormElement) {
        e = new URLSearchParams(new FormData(filter));
        currentParams.getAll('shape').forEach(function(shape){
            if (shape && !e.getAll('shape').includes(shape)) e.append('shape', shape);
        });
    } else {
        // The main /collections/rings-1 template uses Shopify's native
        // collection markup and has no ring filter form. Build the backend
        // query from the URL so it follows the same ordering as ring subpages.
        e = currentParams;
    }

    e.delete('band');
    wooviewParamsObject = formDataToObject(e);
    if (window.location.pathname === '/collections/rings-1'
            && (!wooviewParamsObject.styles || wooviewParamsObject.styles.length === 0)) {
        // Keep the all-rings page scoped to its Shopify collection while the
        // backend applies custom.ring_display_order within that collection.
        wooviewParamsObject.styles = ['Rings'];
    }
    var ajax_url = `${url}${e.toString()}`;
    history.replaceState({}, "", ajax_url);

}
function getFilterByUrl() {
    const params = new URLSearchParams(window.location.search);
    wooviewParamsObject =formDataToObject(params);
    if(wooviewParamsObject.metals && wooviewParamsObject.metals.length>0){
        setFilterByUrlChecked("metal",wooviewParamsObject.metals);
    }
    if(wooviewParamsObject.styles && wooviewParamsObject.styles.length>0){
        var styleText = wooviewParamsObject.styles[0];
        wv$(".select-style-text").text(styleText);
        var checkboxes = wv$('input[type="checkbox"][name="style"]');
        wv$(checkboxes[0]).val(styleText);
        var items = wv$(".style_checkbox");
        if(items && items.length>0){
            items.each(function() {
                var val = wv$(this).text();
                if(val==styleText){
                    wv$(this).addClass("filter_active");
                }
            });
        }

    }
}
function setFilterByUrlChecked(name,lists) {
    var checkboxes = wv$('input[type="checkbox"][name="'+name+'"]');
    // 遍历处理每个checkbox
    checkboxes.each(function() {
        var val = wv$(this).val();
        for(var i=0;i<lists.length;i++){
            var item = lists[i];
            if(item==val){
                wv$(this).prop('checked', true);
                wv$(this).parent().addClass("filter_active");
            }
        }

    });
}
getFilterByUrl();
// 初始化
async function sortNativeRingsByBackendOrder() {
  if (!content) return;

  // Grid sizing belongs to the destination slot, not to the product's identity.
  function getSlotLayoutClasses(card) {
    return Array.from(card.classList).filter(function (name) {
      return name === "item-row2-right" || /^item-row2-right-\d+$/.test(name);
    });
  }

  function applySlotLayoutClasses(card, slotClasses) {
    getSlotLayoutClasses(card).forEach(function (name) {
      card.classList.remove(name);
    });
    slotClasses.forEach(function (name) {
      card.classList.add(name);
    });
  }

  var orderedItems = [];
  var page = 0;
  var hasMore = true;
  var params = {
    page: page,
    shopDomain: "https://" + Shopify.shop,
    productType: 1,
    styles: ["Rings"]
  };

  try {
    // Shopify metafields take priority for the products on the current collection page.
    var orderData = container.querySelector('[data-valthea-ring-display-order]');
    if (orderData) {
      try {
        var localOrders = JSON.parse(orderData.textContent);
        if (Array.isArray(localOrders)) {
          localOrders.forEach(function (item) {
            if (item.handle && item.order !== null && item.order !== '' && Number.isFinite(Number(item.order))) {
              orderedItems.push({ handle: item.handle, order: Number(item.order) });
            }
          });
        }
      } catch (parseError) {
        console.error('Unable to read Shopify ring display order:', parseError);
      }
    }
    if (!orderedItems.length) for (; hasMore && page < 50;) {
      params.page = page;
      var response = await fetch(baseUrl + "/store/product/ring/list", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params)
      });
      if (!response.ok) throw new Error("HTTP error! status: " + response.status);

      var data = await response.json();
      var items = data && Array.isArray(data.content) ? data.content : [];
      items.forEach(function (item) {
        if (item.urlHandle && item.ringSortOrder !== null && item.ringSortOrder !== undefined) {
          orderedItems.push({ handle: item.urlHandle, order: Number(item.ringSortOrder) });
        }
      });
      hasMore = items.length > 0 && data.last !== true;
      page++;
    }

    var cards = Array.from(content.querySelectorAll(".product-card--root[data-handle]"));
    if (!cards.length || !orderedItems.length) return;

    var slotLayouts = cards.map(getSlotLayoutClasses);
    orderedItems.sort(function (a, b) { return a.order - b.order; });
    var rank = new Map(orderedItems.map(function (item, index) {
      return [item.handle, index];
    }));
    var originalRank = new Map(cards.map(function (card, index) {
      return [card, index];
    }));
    var sortedCards = cards.slice().sort(function (a, b) {
      var aRank = rank.has(a.dataset.handle) ? rank.get(a.dataset.handle) : Number.MAX_SAFE_INTEGER;
      var bRank = rank.has(b.dataset.handle) ? rank.get(b.dataset.handle) : Number.MAX_SAFE_INTEGER;
      return aRank - bRank || originalRank.get(a) - originalRank.get(b);
    });

    // Promotion images and buttons stay in their original DOM slots.
    var slots = cards.map(function (card) {
      var marker = document.createComment("ring-sort-slot");
      card.replaceWith(marker);
      return marker;
    });
    slots.forEach(function (slot, index) {
      var card = sortedCards[index];
      applySlotLayoutClasses(card, slotLayouts[index]);
      slot.replaceWith(card);
    });
    content.setAttribute("data-ring-backend-sorted", "true");

    // A card can move between a large and small slot after Swiper initialized.
    window.requestAnimationFrame(function () {
      content.querySelectorAll(".product-card__image-swiper").forEach(function (container) {
        if (container.swiper && !container.swiper.destroyed) container.swiper.update();
      });
    });
  } catch (error) {
    console.error("Unable to apply ring display order:", error);
  } finally {
    document.documentElement.classList.remove('valthea-rings-sorting');
  }
}

// 四个分类按 Shopify 商品标记筛选；导航 Rings 返回无标签的总集合。
// 保留集合当前的模板、图片、文案、布局和 Shopify 原生分页。
function valtheaConfigureRingsNavigation() {
    var route = window.location.pathname.match(
        /^((?:\/[^/]+)?\/collections\/rings-1)(?:\/([^/]+))?\/?$/i
    );
    if (!route) return null;

    var basePath = route[1];
    var categories = {
        statement: "statement",
        anniversary: "anniversary",
        eternity: "eternity",
        stacking: "stacking"
    };

    document.querySelectorAll(
        ".collection-filtrate-picture-main .image-container a"
    ).forEach(function (link) {
        var label = link.querySelector("span");
        var name = (label ? label.textContent : link.textContent)
            .trim()
            .toLowerCase();

        if (Object.prototype.hasOwnProperty.call(categories, name)) {
            link.setAttribute("href", basePath + "/" + categories[name]);
        }
    });

    // Rings 链接移除分类、分页及筛选条件，返回全部已发布戒指的集合。
    document.querySelectorAll("a[href]").forEach(function (link) {
        var label = link.textContent.replace(/\s+/g, " ").trim().toLowerCase();
        if (label !== "rings") return;

        try {
            var url = new URL(link.getAttribute("href"), window.location.origin);
            var isThisCollection =
                /^((?:\/[^/]+)?\/collections\/rings-1)(?:\/[^/]+)?\/?$/i.test(url.pathname);

            if (url.origin === window.location.origin && isThisCollection) {
                link.setAttribute("href", basePath);
            }
        } catch (error) {
            // 保留无法解析的原链接。
        }
    });

    return route;
}

var valtheaRingsRoute = valtheaConfigureRingsNavigation();

// Earrings 使用 Shopify 原生集合商品，跳过戒托接口初始化。
var valtheaIsEarringsPage =
    /^(?:\/[^/]+)?\/collections\/earrings(?:\/[^/]+)?\/?$/i.test(window.location.pathname);

if (container && content && !valtheaIsEarringsPage) {
    if (valtheaRingsRoute) {
        if (!valtheaRingsRoute[2]) {
            // 无标签的总页面展示 Rings 集合的全部可展示商品，保留原分页。
            // 接口仅提供排序，不新增、删除或过滤集合商品。
            sortNativeRingsByBackendOrder();
        }
        // 分类页直接保留 Shopify 根据商品标记生成的筛选结果。
    } else {
        // 其他戒指定制页面维持原有接口及筛选功能。
        initContent();
        setupListeners();
    }
}



